import type {QueryClient} from '@tanstack/react-query';

let _client: QueryClient | null = null;

export const setQueryClient = (client: QueryClient) => {
  _client = client;
};

export const getQueryClient = () => {
  if (!_client) throw new Error('QueryClient not initialized yet');
  return _client;
};

export const clearReactQueryCache = () => {
  const qc = getQueryClient();
  qc.clear(); // clears queries + mutations
};
